import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import insightsReducer from './slices/insightsSlice';
import interviewsReducer from './slices/interviewsSlice';
import tagsReducer from './slices/tagsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    insights: insightsReducer,
    interviews: interviewsReducer,
    tags: tagsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
